import { all, call, select, takeLatest } from 'redux-saga/effects';
import { getRoutineSaga } from '../common/utils/saga';
import { showMessageSaga } from '../messages/saga';
import { SUBMIT_FORM } from '../schema-form/action-types';
import { getProjectWebhooks, updateProjectWebhooks } from './actions';
import { getWebhooksQuery, updateWebhooksMutation } from './api';
import { WEBHOOKS_FORM_NAME } from './constants';
import { getWebhooksUpdate } from './selectors';

export function* updateProjectWebhooksSaga() {
  const update = yield select(getWebhooksUpdate);
  return yield call(updateWebhooksMutation, { input: update });
}

const webhookFormSubmit = (action) =>
  action.type === `${SUBMIT_FORM}_SUCCESS` && action.meta.formName === WEBHOOKS_FORM_NAME;

export default function* root() {
  yield all([
    takeLatest(webhookFormSubmit, getRoutineSaga(updateProjectWebhooks, updateProjectWebhooksSaga)),
    takeLatest(getProjectWebhooks.REQUESTED, getRoutineSaga(getProjectWebhooks, getWebhooksQuery)),
    takeLatest(
      getProjectWebhooks.REJECTED,
      showMessageSaga('error', (a) => a.payload.rawError[0].message, 5000)
    ),
    takeLatest(updateProjectWebhooks.FULFILLED, showMessageSaga('info', 'Project Webhooks Updated', 5000)),
    takeLatest(updateProjectWebhooks.REJECTED, showMessageSaga('error', 'Project Webhooks Update Failed', 5000))
  ]);
}
